import { FileText, MessageCircle, Paperclip, CheckSquare } from 'lucide-react';

/**
 * Notes List widget constants.
 * Icon config for the note icon highlight: uses amber (orange) background per Figma.
 */
export const NOTE_ICON_CONFIG = Object.freeze({
  icon: FileText,
  bgColor: 'bg-amber-100 dark:bg-amber-950/50',
  iconColor: 'text-amber-600 dark:text-amber-400',
});

export const NOTES_CARD_MAX_CHARACTERS = 80;

/** Maps metadata keys to Lucide icon components */
export const NOTES_METADATA_ICONS = Object.freeze({
  comments: MessageCircle,
  attachments: Paperclip,
  tasks: CheckSquare,
});

export { NOTES_STATE_COPY } from '../../../../constants';
